export enum OutlookEventDispId {
    DISPLAY_DIALOG_DISPID = 10,

    DIALOG_NOTIFICATION_SHOWN_IN_ADDIN_DISPID = 11,

    ITEM_CHANGED_EVENT_DISPID = 46,

    RECIPIENTS_CHANGED_EVENT_DISPID = 47,

    APPOINTMENT_TIME_CHANGED_EVENT_DISPID = 48,

    RECURRENCE_CHANGED_EVENT = 49,

    ATTACHMENTS_CHANGED_EVENT_DISPID = 50,

    LOCATIONS_CHANGED_EVENT = 51,
}
